// src/components/AuthorListItem.jsx
import React, { useState } from 'react';
import config from '../../../config';

export default function AuthorListItem({ author }) {
  const [showBio, setShowBio] = useState(false);


  return (
    <div
      onClick={() => setShowBio(!showBio)}
      className="
        relative flex items-center p-4 mb-4
        bg-white/50 backdrop-blur-md rounded-2xl
        shadow inner-shadow hover:shadow-lg
        transition-all duration-300 ease-in-out
        cursor-pointer
      "
    >
      {/* Accent stripe */}
      <div className="absolute left-0 top-0 bottom-0 w-1 bg-primary rounded-l-xl" />

      {/* Avatar */}
      <img
         src={
          author.image
            ? `${config.url}/authorImages/${author.image}`
            : "/images/default_author_img.png"
        }

        onError={(e) => {
          e.target.onerror = null;
          e.target.src = "/images/default_author_img.png";
        }}
        alt={author.name}
        className="
          flex-shrink-0 w-16 h-16 rounded-full
          border-2 border-white shadow-md
          transform hover:scale-105 transition-transform duration-300
        "
      />

      {/* Text Content */}
      <div className="ml-4 flex-1">
        <h4
          className="
            text-lg font-semibold text-gray-900
            group-hover:text-primary transition-colors duration-300
          "
        >
          {author.name}
        </h4>

        {/* Bio snippet */}
        <p
          className={`
            mt-1 text-sm text-gray-600 
            ${showBio ? 'line-clamp-none' : 'line-clamp-2'}
            transition-all duration-300
          `}
        >
          {author.aboutAuthor}
        </p>
      </div>

      {/* Expand/collapse indicator */}
      <div className="ml-2 text-gray-500">
        {showBio ? '▲' : '▼'}
      </div>
    </div>
  );
}
